import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const steps = [
  {
    number: '01',
    title: 'Paste Your Text',
    description: 'Copy any text from anywhere and paste it into the input field. No limits on length.'
  },
  {
    number: '02',
    title: 'Choose a Format',
    description: 'Click on the case style you need — sentence, lower, upper, title, or any other option.'
  },
  {
    number: '03',
    title: 'Copy or Download',
    description: 'Your converted text appears instantly. Copy it to clipboard or download as a .txt file.'
  }
];

export const HowItWorksSection = () => {
  return (
    <section className="py-16 md:py-24 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Section header */}
          <div className="text-center mb-12">
            <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground mb-4">
              How It Works
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Converting text has never been easier. Just three simple steps.
            </p>
          </div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <Card 
                key={index} 
                className="border-border/50 bg-card relative overflow-hidden"
              >
                <CardContent className="p-6 pt-8">
                  <div className="absolute top-4 right-4 text-6xl font-bold text-primary/10 font-display leading-none">
                    {step.number}
                  </div>
                  <div className="relative">
                    <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-semibold mb-4">
                      {index + 1}
                    </div>
                    <h3 className="font-semibold text-lg text-foreground mb-2">
                      {step.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Additional explanation */}
          <div className="mt-12 text-center">
            <p className="text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              CaseFlip is designed for simplicity. There&apos;s no learning curve, no complex settings, 
              and no waiting. Your text is transformed the moment you click a button, and the result 
              preserves all your original spacing and line breaks. It&apos;s the fastest way to format 
              text for any purpose.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
